import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import SanctionsTable from '../../../SanctionsWarnings/SanctionsWarningsTable';

export default class SanctionsSection extends Component {

    static propTypes = {
        entityName: PropTypes.string
    };

    static defaultProps = {
        entityName: null
    };

    componentWillMount() {
        this.props.resetSanctions();
        this.props.loadItems(this.props.entityName, this.props.companyId)
    }

    render() {
        return (
            <div className={"sanctions-section " + (this.props.items && this.props.items.length ? "with-results" : "")}>
                { this.props.totalCount !== 0 || (this.props.totalCount === 0 &&  this.props.hasError) ? (
                    <div>
                        <div className="sanctions-section__results">
                            <div className="sanctions-section__results--header">
                                {this.props.entityName}: <FormattedMessage
                                id="Dashboard_SingleView_UIText_sanctionsAndWarnings_sanctionsAndWarningsReports" />
                            </div>
                            <div className="sanctions-section__results--body">
                                <SanctionsTable { ...this.props } entityName={this.props.entityName} companyId={this.props.companyId}/>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="sanctions-section__smiley">
                        <div className="sanctions-section__smiley--image"></div>
                        <div className="sanctions-section__smiley--content">
                            <div className="sanctions-section__smiley--content-wrapper">
                                <span><b>{this.props.entityName}</b></span> <FormattedMessage
                                id="Dashboard_SingleView_UIText_sanctionsAndWarnings_noSanctions" />
                            </div>
                        </div>
                    </div>
                )}
            </div>

        );
    };

}




// WEBPACK FOOTER //
// ./src/scripts/pages/EntityDashboard/components/EntityAnalysis/SanctionsSection.jsx